// Format number to Rupiah with proper formatting (Indonesian format)
export function formatRupiah(value: any): string {
  if (!value || value === '' || value === '0') return '';
  const numValue = typeof value === 'string' ? parseFloat(value) : Number(value);
  if (isNaN(numValue) || numValue === 0) return '';
  // Format without decimal places, using dot as thousand separator
  return new Intl.NumberFormat('id-ID').format(numValue);
}

// Parse Rupiah format back to number
export function parseRupiah(value: string): string {
  if (!value) return '';
  // Remove all non-digit characters (including dots and commas)
  return value.toString().replace(/\D/g, '');
}
